module.exports = "<div class=\"simple-pagination-container\">\n    <button [disabled]=\"getCurrentPage() === 0\"\n            (click)=\"changePage(-1)\"\n            class=\"btn btn-default btn-simple-pagination\">\n        < &#160; previous page\n    </button>\n    <button [disabled]=\"getCurrentPage() + 1 >= totalPages\"\n            (click)=\"changePage(1)\"\n            class=\"btn btn-default btn-simple-pagination\">\n        next page &#160; >\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/simple-pagination/simple-pagination.html
// module id = ./web/modern/components/buttons/simple-pagination/simple-pagination.html
// module chunks = 0